module.exports = __webpack_public_path__ + "static/Step2-a0b8d830582bf2228746f9e3ef45d304.svg";